import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../services/auth-service/auth.service';
import { NavBarComponent } from '../nav-bar/nav-bar.component';
import { ApplicationUrlSettings } from '../settings/ApplicationUrlSettings';

@Component({
  selector: 'app-driver-g-authorization-callback',
  templateUrl: './driver-g-authorization-callback.component.html',
  styleUrls: ['./driver-g-authorization-callback.component.css']
})
export class DriverGAuthorizationCallbackComponent implements OnInit {
  navOptions = NavBarComponent.standard;
  constructor(private route:ActivatedRoute,private router:Router,private auth:AuthService) { }

  ngOnInit() {
    let token = this.route.snapshot.queryParams.t;
  }

  downloadApp() {
    window.open(`${ApplicationUrlSettings.NODE_API_URL}download-android`, "_blank");
  }


}



// WEBPACK FOOTER //
// ./src/app/driver-g-authorization-callback/driver-g-authorization-callback.component.ts